export const REDIRECT_AFTER_LOGIN_KEY = 'redirectAfterLogin';

function validatePostLoginRedirectPath(path: string | null): string | null {
  if (
    path &&
    path.startsWith('/') &&
    !path.startsWith('//') &&
    path !== '/sessionExpired'
  ) {
    return path;
  }
  return null;
}

/** Read the post-login redirect path without removing it (survives login-page remounts). */
export function getPostLoginRedirect(): string | null {
  const path = localStorage.getItem(REDIRECT_AFTER_LOGIN_KEY);
  return validatePostLoginRedirectPath(path);
}

export function savePostLoginRedirect(path: string): void {
  const validated = validatePostLoginRedirectPath(path);
  if (!validated) return;
  localStorage.setItem(REDIRECT_AFTER_LOGIN_KEY, validated);
}

export function clearPostLoginRedirect(): void {
  localStorage.removeItem(REDIRECT_AFTER_LOGIN_KEY);
}
